import Cart from "../components/Cart";
const cart = new Cart({});

export default cart;